import * as S from "../ConvenienceTest.style";
import ModalComplete from "./ModalComplete";
import { useContext, useEffect, useState } from "react";
import Auth from "../../../Auth/Auth";
import { UserIdentityType } from "../../../services/UserIdentitiesService";
import SavingsPlanService, {
  SavingsPlanType,
  SavingsPlanTypes,
} from "../../../services/SavingsPlanService";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { SignatureComponent } from "../../../components/Signature/SignatureComponent";
import Moment from "moment";
import { ISignature } from "../../../services/SignaturesService";
import { Spinner, SpinnerSize } from "@fluentui/react";
import scrollToTop from "../../../utils/scrollToTop";
import React from "react";
import DocumentTitle from "react-document-title";
import { useDispatch } from "react-redux";
import { setActiveSavingsPlan } from "../../../store/auth/actions";
import { ThemeContext } from "@fluentui/react-theme-provider";
import { TicketSupportContainer } from "../../TicketSupport/TicketSupport.style";
import { ModalWithCancel } from "../../Modals/ModalWithCancel";
import TicketSupportService, {
  TicketSupportData,
} from "../../../services/TicketSupportService";
import TicketSupport from "../../TicketSupport/TicketSupport";
import {
  MODAL_TITLE_SUCCESS,
  PARTIAL_MODAL_BODY_SUCCESS,
  MODAL_TITLE_ERROR,
  MODAL_BODY_ERROR,
  ScreenStepType,
} from "../../TicketSupport/TicketSupportConstants";

const ConvenienceTestConfirm = () => {
  const { savingsPlanId } = useParams<any>();
  const history = useHistory();
  const isPromotioned = Auth.isPromotioned();
  const theme = useContext(ThemeContext);
  const [userIdentities, setUserIdentities] = useState<UserIdentityType[]>([]);
  const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>();
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState();
  const { state } = useLocation<any>();
  const dispatch = useDispatch();

  // ticket soporte + modal
  const [showSupportForm, setShowSupportForm] = useState(false);
  const [showSupportResultModal, setShowSupportResultModal] = useState(false);
  const [modalSupportResultTitle, setModalSupportResultTitle] = useState("");
  const [modalSupportResultBody, setModalSupportResultBody] = useState("");
  const [ticketSupportError, setTicketSupportError] = useState({
    status: false,
    message: "",
  });

  // -------------------------------------------------------------------
  // Ticket soporte
  // -------------------------------------------------------------------
  const handleSupportSend = async (ticketData: TicketSupportData) => {
    try {
      const response = await TicketSupportService.createNewSupportTicket(
        ticketData
      );

      if (response && response.Status === 200) {
        setModalSupportResultTitle(MODAL_TITLE_SUCCESS);
        setModalSupportResultBody(
          `Ticket con referencia: ${
            response.Id ?? "N/A"
          } ${PARTIAL_MODAL_BODY_SUCCESS}`
        );
      } else {
        setModalSupportResultTitle(MODAL_TITLE_ERROR);
        setModalSupportResultBody(MODAL_BODY_ERROR);
      }
    } catch (error) {
      console.error(`${MODAL_TITLE_ERROR} :`, error);
      setModalSupportResultTitle(MODAL_TITLE_ERROR);
      setModalSupportResultBody(MODAL_BODY_ERROR);
    } finally {
      setShowSupportResultModal(true);
    }
  };

  const processExpirationDate = (signatures: ISignature[]) => {
    if (signatures !== undefined && signatures.length > 0) {
      signatures.forEach((signature: ISignature) => {
        if (signature && typeof signature.expiresAt === "string") {
          signature.expiresAt = Moment(signature.expiresAt).toDate();
        }
      });
    }
  };

  let defaultSignatures: any = state?.signatures;
  processExpirationDate(defaultSignatures);

  const [signatures, setSignatures] = useState(defaultSignatures);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    SavingsPlanService.getSavingsPlan(savingsPlanId).then(
      (savingsPlan: SavingsPlanType) => {
        setSavingsPlan(savingsPlan);
        console.log("SAVING PLAN:", savingsPlan);
      },
      (error) => {
        setError(error);
        setTicketSupportError({
          status: false,
          message: JSON.stringify(error),
        });
        setIsLoaded(true);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      savingsPlan !== undefined &&
      savingsPlan.savingsPlansUserIdentities !== undefined
    ) {
      setUserIdentities(
        savingsPlan.savingsPlansUserIdentities.map(
          (savingsPlanUserIdentity) => savingsPlanUserIdentity.userIdentity
        )
      );
      setIsLoaded(true);
    }
  }, [savingsPlan]);

  useEffect(() => {
    setPhoneNumbers(
      userIdentities
        .filter((uI) => {
          var currentDate = Moment();
          var birthdayDate = Moment(uI.birthday);
          return currentDate.diff(birthdayDate, "years") > 17;
        })
        .map(
          (userIdentity: any) =>
            "X".repeat(userIdentity.phone.length - 3) +
            userIdentity.phone.slice(
              userIdentity.phone.length - 3,
              userIdentity.phone.length
            )
        )
        .join(", ")
    );
  }, [userIdentities]);

  const handleSubmit = async () => {
    if (savingsPlan !== undefined) {
      if (savingsPlan?.status !== 4) {
        SavingsPlanService.patchSavingsPlan(savingsPlanId, {
          status: 1,
          configurationMapStep: "3.1",
        }).then(
          () => {
            if (savingsPlan?.type === SavingsPlanTypes.ExperienceSample) {
              history.push(`/elements-contract/${savingsPlan.id}`);
            } else {
              history.push("/configurationMap", {
                savingPlanId: savingsPlan.id,
                savingPlanName: savingsPlan.name,
              });
            }
          },
          (error: any) => {
            setError(error);
          }
        );
      } else {
        const activePlan = Auth.getActivePlan();
        Auth.setActivePlan({ ...activePlan, outdatedContract: false });
        await dispatch(
          setActiveSavingsPlan({
            ...activePlan,
            outdatedContract: false,
            sync: true,
          })
        );
        history.push("/configurationMap", {
          savingPlanId: savingsPlan.id,
          savingPlanName: savingsPlan.name,
        });
      }
    }
    if (!state?.signatures || !modalShow) {
      scrollToTop();
      if (savingsPlan?.status !== 4) {
        setModalShow(true);
      }
    }
  };

  return (
    <>
      {/* Soporte */}
      <TicketSupportContainer>
        <TicketSupport
          showSupportForm={showSupportForm}
          setShowSupportForm={setShowSupportForm}
          onSupportSend={handleSupportSend}
          userIdentities={userIdentities}
          component={"ConvenienceTestConfirm"}
          savingPlanId={savingsPlanId}
          screenName={ScreenStepType.FirmaContratoPlanAhorroConvenience}
          ticketSupportError={ticketSupportError}
        />
      </TicketSupportContainer>
      <DocumentTitle title={`IronIA - Confirmación`}>
        <React.Fragment>
          <S.HelperStyle />
          <S.Cont theme={theme}>
            <S.MainCont>
              {!isLoaded && <Spinner size={SpinnerSize.large} />}
              {isLoaded && (
                <SignatureComponent
                  signatures={signatures}
                  userIdentities={userIdentities}
                  title="Firma del contrato"
                  submitButtonText="Firmar contrato"
                  cancelButtonText="Volver"
                  alreadySignedText="Enhorabuena, ¡ya tienes tu plan de cartera!"
                  headerTextArea={
                    "A continuación te incluimos los detalles del contrato con nosotros. Léelo y cuando estés listo, dale al botón " +
                    "de 'Solicitar SMS'. Te enviaremos un código SMS por cada interviniente" +
                    (userIdentities.length > 1
                      ? ` a los números ${phoneNumbers} `
                      : userIdentities.length === 1
                      ? ` al número ${phoneNumbers} `
                      : " ") +
                    "para realizar la firma del contrato."
                  }
                  backButtonText="Volver"
                  onBackButtonClicked={() =>
                    history.push("/contract/" + savingsPlanId)
                  }
                  onCancelButtonClicked={() =>
                    history.push("/contract/" + savingsPlanId)
                  }
                  requestNewCodeButtonText="Recibir nuevo código"
                  onNewCodeSended={(signatures: any) => {
                    processExpirationDate(signatures);
                    setSignatures(signatures);
                  }}
                  onSignatureChanged={(signatures: any) => {
                    processExpirationDate(signatures);
                    setSignatures(signatures);
                  }}
                  onSigned={handleSubmit}
                />
              )}
              {error && <div>Alguno de los códigos enviados no es válido</div>}
            </S.MainCont>
          </S.Cont>
          {modalShow && (
            <ModalComplete
              setModalShow={setModalShow}
              isPromotioned={isPromotioned}
            />
          )}
        </React.Fragment>
      </DocumentTitle>

      {/* Modal de confirmación */}
      <ModalWithCancel
        showModal={showSupportResultModal}
        setShowModal={setShowSupportResultModal}
        title={modalSupportResultTitle}
        body={modalSupportResultBody}
        onClose={() => setShowSupportResultModal(false)}
        btnSubmitText="Cerrar"
      />
    </>
  );
};

export default ConvenienceTestConfirm;
